import React from 'react'
import { Transformation } from 'cloudinary-react'
import DfbAnchor from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_anchor'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import { conditionalLinkTarget } from '@dfb/gatsby-dfb-theme/src/components/utilities'

function CCardInfoTeaser({ headline, overline, description, link, link_obj, link_text, image }) {
  return (
    <a className="dfb-Card m-CardNews-card" href={link} {...conditionalLinkTarget(link, link_obj)}>
      <div className="dfb-Card-imageContainer">
        <DfbImage image={image} aspect_ratio="16:9" add_class="m-CardGrid-image">
          <Transformation crop="fill" gravity="faces:center" width="720" height="405" quality="auto" fetchFormat="auto" />
        </DfbImage>
      </div>

      <div className="dfb-Card-content">
        {overline && <div className="dfb-Card-topline">{overline}</div>}
        {headline && <h4 className="dfb-Headline dfb-Card-headline">{headline}</h4>}
        {description && <p className="dfb-Paragraph dfb-Card-description wtf">{description}</p>}
      </div>
      <div className="dfb-Card-footer" data-testid="news-footer-load-more">
        <DfbAnchor tagName="span" secondary {...conditionalLinkTarget(link, link_obj)} text={link_text} />
      </div>
    </a>
  )
}

export default CCardInfoTeaser
